module.exports = __webpack_public_path__ + "img/logo3.00a1d0e9.png";